import React from "react";
import { User, Session } from "../../types/Types";
import UserTag from "../../users/tag/UserTag";
import LocationTag from "../../tag/LocationTag";
import DateTime from "../../date/DateTime";
import { getDateFromTimeStamp } from "../../util/Util";
import { Link } from "react-router-dom";

interface Like {
    id: string;
    userId: string;
    userName: string;
    likeType: string;
    entityId: string;
    locationId: string;
    locationName: string;
    createdAt: Date;
}

interface Props {
    like: Like;
    usersMap: Map<string, User>;
    sessionsMap: Map<string, Session>;
}

const PhotoLikedRow: React.FC<Props> = ({ like, usersMap, sessionsMap }) => {
    const isCheckedIn = (userId: string): boolean => {
        const session = sessionsMap.get(userId);
        return (session && getDateFromTimeStamp(session.checkOutTime) > new Date()) || false;
    };

    return (
        <div className={"news-item"}>
            <div className={"d-inline-block"}>
                <div className={"d-inline-block"}>
                    <UserTag 
                        user={usersMap.get(like.userId)} 
                        visit={undefined} 
                        session={sessionsMap.get(like.userId)} 
                        padRight={false} 
                        hideLocationDot={false} 
                        linksToTab={"photos"}
                    />
                </div>
                <div className={"d-inline-block mr-1"}>
                    liked a
                </div>
                <div className={"d-inline-block mr-1"}>
                    <Link to={`/photo/${like.entityId}`}>
                        <div className={`user-tag d-inline-block`}>
                            photo
                        </div>
                    </Link>
                </div>
                <div className={"d-inline-block mr-1"}>
                    of
                </div>
                <LocationTag 
                    name={like.locationName} 
                    id={like.locationId} 
                    session={sessionsMap.get(like.userId)} 
                    displayVerificationTag={isCheckedIn(like.userId)} 
                    linksToTab={"photos"} 
                />
            </div>
            <DateTime date={like.createdAt}/>
        </div>
    );
};

export default PhotoLikedRow;
